// src/Components/Cadastro/ImportPrices/ListaImportPrices.tsx
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { IListImportPrices } from '../../../Pages/Cadastro/CadImportPrices';
import LayoutFilter from '../../data/LayoutFilter';
import { 
  FaImage, 
  FaFilePdf, 
  FaStore
} from 'react-icons/fa';
import { useAppSelector } from '../../../redux/store';
import * as S from './styled';

export default function ListaImportPrices({
  OnAddNewImport,
  title,
}: IListImportPrices) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const [openFilter, setOpenFilter] = useState<boolean>(false);

  const handleAdd = () => {
    OnAddNewImport(true);
  };

  const onClickOpenFilter = () => {
    setOpenFilter(!openFilter);
  };

  return (
    <>
      <LayoutFilter
        title={title}
        onClickAdd={handleAdd}
        onClickOpenFilter={onClickOpenFilter}
        openFilter={openFilter}
      >
        <S.Wrapper>
          {openFilter && (
            <div className="min-screen">
              <div style={{ padding: '15px' }}>
                <p style={{ color: '#6c757d', fontSize: '14px', margin: '0' }}>
                  Configure os filtros para buscar importações específicas
                </p>
              </div>
            </div>
          )}

          <div className="max-screen">
            <div style={{ padding: '15px' }}>
              <p style={{ color: '#6c757d', fontSize: '14px', margin: '0' }}>
                Configure os filtros para buscar importações específicas
              </p>
            </div>
          </div>
        </S.Wrapper>
      </LayoutFilter>

      {/* Informações da Loja */}
      <div 
        className="containerFilter" 
        style={{ 
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}
      >
        <FaStore style={{ fontSize: '20px', color: '#6c757d' }} />
        <div style={{ flex: 1 }}>
          <div style={{ 
            fontSize: '16px', 
            fontWeight: '600', 
            color: '#495057'
          }}>
            {storeMe?.storeActive?.name || 'Loja Não Identificada'}
          </div>
          <div style={{ fontSize: '13px', color: '#6c757d' }}>
            ID: #{storeMe?.storeActive?.id || 'N/A'}
          </div>
        </div>
      </div>

      {/* Métodos de Importação */}
      <Row style={{ marginBottom: '20px' }}>
        <Col md={6} style={{ marginBottom: '15px' }}>
          <div 
            className="containerFilter" 
            style={{ 
              height: '100%',
              backgroundColor: '#fff',
              border: '2px solid #e83e8c',
              borderRadius: '8px',
              textAlign: 'center',
              padding: '40px 20px',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onClick={handleAdd}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#fce4ec';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#fff';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <FaImage style={{ 
              fontSize: '56px', 
              color: '#e83e8c', 
              marginBottom: '20px' 
            }} />
            <h3 style={{ 
              fontSize: '22px', 
              color: '#e83e8c', 
              marginBottom: '8px',
              fontWeight: '600'
            }}>
              Importar por Imagem
            </h3>
            <p style={{ 
              fontSize: '14px', 
              color: '#6c757d', 
              margin: '0'
            }}>
              JPG, PNG, JPEG (máx. 50MB)
            </p>
          </div>
        </Col>

        <Col md={6} style={{ marginBottom: '15px' }}>
          <div 
            className="containerFilter" 
            style={{ 
              height: '100%',
              backgroundColor: '#fff',
              border: '2px solid #dc3545',
              borderRadius: '8px',
              textAlign: 'center',
              padding: '40px 20px',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onClick={handleAdd}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f8d7da';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#fff';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <FaFilePdf style={{ 
              fontSize: '56px', 
              color: '#dc3545', 
              marginBottom: '20px' 
            }} />
            <h3 style={{ 
              fontSize: '22px', 
              color: '#dc3545', 
              marginBottom: '8px',
              fontWeight: '600'
            }}>
              Importar por PDF
            </h3>
            <p style={{ 
              fontSize: '14px', 
              color: '#6c757d', 
              margin: '0'
            }}>
              Formato PDF (máx. 50MB)
            </p>
          </div>
        </Col>
      </Row>
    </>
  );
}